import { Box } from '@twilio-paste/core/box';
import { Menu, MenuButton, MenuItem, useMenuState } from '@twilio-paste/core/menu';
import { MoreIcon } from '@twilio-paste/icons/esm/MoreIcon';

import { ScopeModel } from '../../../../modules/Apps';
import { Action, Subject } from '../../../../modules/Permissions';
import { Can } from '../../../common/AbilityContext';

import { useScopesTableActions } from './lib';


interface ScopesTableActionsParams {
  scope: ScopeModel;
}

export function ScopesTableActions({ scope }: ScopesTableActionsParams) {
  const menu = useMenuState();
  const { openEditScopeDrawer, openViewScopeDrawer } = useScopesTableActions();

  return (
    <Box display="flex" justifyContent="center">
      <MenuButton {...menu} variant="reset" size="reset">
        <MoreIcon decorative={false} title="More options" />
      </MenuButton>
      <Menu {...menu} aria-label="Preferences">
        <Can I={Action.View} a={Subject.Scope}>
          <MenuItem {...menu} onClick={openViewScopeDrawer(scope)}>
            View
          </MenuItem>
        </Can>
        <Can I={Action.Edit} a={Subject.Scope}>
          <MenuItem {...menu} onClick={openEditScopeDrawer(scope)}>
            Edit
          </MenuItem>
        </Can>
      </Menu>
    </Box>
  );
}
